// extracted by mini-css-extract-plugin
export default {"zero":"Cell_zero__PT9Hw","placeHolderShimmer":"Cell_placeHolderShimmer__Dj89e"};